// src/index.tsx
import React from "react";
import { render } from "react-dom";
import KeycloakProviderWrapper from "./utils/hooks/KeycloakProviderWrapper";
import "./assets/fonts/font.scss";
import { HashRouter } from "react-router-dom";
import App from "./app";

const rootElement = document.getElementById("root");
render(
  <KeycloakProviderWrapper>
    <HashRouter>
      <App />
    </HashRouter>
  </KeycloakProviderWrapper>,
  rootElement
);